import { Text } from '@cubeyou-team/hx-react-components';
import classnames from 'classnames';
import React, { FC } from 'react';

import translations from 'src/lang';

const { STANLEY_QUERY: translation } = translations['en-US'];
const { BADGE } = translation.MODAL.QUERY_ITEM;

const COMPLEXITIES = {
  complex: BADGE.COMPLEX,
  intermediate: BADGE.INTERMEDIATE,
  simple: BADGE.SIMPLE,
} as const;

export type Complexity = keyof typeof COMPLEXITIES;

const COMPLEXITY_COLOR_MAP = {
  complex: 'bg-accent-2',
  intermediate: 'bg-accent-1',
  simple: 'bg-accent-3',
};
interface QueryItemBadgeProps {
  index?: number;
  complexity?: Complexity;
}
export const QueryItemBadge: FC<QueryItemBadgeProps> = ({
  index,
  complexity,
}) => {
  return (
    <div
      className={classnames('p-2 rounded', {
        [COMPLEXITY_COLOR_MAP[complexity]]: complexity,
        'bg-black': !complexity,
      })}
    >
      <Text size="xbody" weight="bold" variant="light">
        {index
          ? `${BADGE.OPTION} ${index}`
          : complexity
          ? COMPLEXITIES[complexity]
          : ''}
      </Text>
    </div>
  );
};
